module.exports = __webpack_public_path__ + "img/check.f63501e8.svg";